// extracted by mini-css-extract-plugin
export default {"main":"DossierNotes_main__ZfrDh","label":"DossierNotes_label__Ff+mS","noteInput":"DossierNotes_noteInput__v+d75","notes":"DossierNotes_notes__1uAUJ"};